import { DataService } from "app/shared/services/dataService";
import { UserService } from 'app/shared/services/userService';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-resource-center',
  templateUrl: './resource-center.component.html',
  styleUrls: ['./resource-center.component.css']
})
export class ResourceCenterComponent implements OnInit {
  
  isAdminUser = false;
  jurisdiction = "general";
  jurisdictionOptions: Array<any> =[];

  constructor(
    private dialogRef: MatDialogRef<ResourceCenterComponent>,
    private dataService: DataService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.GetUserGroups().then(groups => {
      this.jurisdictionOptions = this.jurisdictionOptions.concat(groups.map((g) => ( { name: g, value:g.replace(' ', '_') } ) ));
   
      if(this.jurisdictionOptions.length === 1){
        this.jurisdiction = this.jurisdictionOptions[0].value;
      }
    });

    this.dataService.getAccess().subscribe((access) => {
      this.isAdminUser = access.IsAdmin;
    });
  }

  onCloseModal(event: any) {
    this.dialogRef.close();
  }
}